function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 16"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M.2 16h4.52c1.03 0 2.26-1.2 2.26-2.13V0H2.46C1.44 0 .21 1.2.21 3.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.77 10.82a9.77 9.77 0 01-2.56-.34V9.3c.64.38 1.38.6 2.14.62.87 0 1.36-.58 1.36-1.37V5.33h2.14v3.23c0 1.25-.7 2.26-3.08 2.26z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.11 16h4.52c1.03 0 2.26-1.2 2.26-2.13V0h-4.52C9.34 0 8.11 1.2 8.11 3.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.11 6.08c.66-.6 1.79-.97 3.62-.89.99.05 2.03.32 2.03.32V6.7a4.79 4.79 0 00-1.96-.6c-1.39-.13-2.23.6-2.23 1.9s.85 2.03 2.23 1.92a4.85 4.85 0 001.96-.62v1.18s-1.04.28-2.03.33c-1.83.08-2.96-.3-3.62-.89z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.02 16h4.52c1.02 0 2.26-1.2 2.26-2.13V0h-4.52c-1.03 0-2.26 1.2-2.26 3.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.66 9.28c0 .85-.7 1.39-1.63 1.39h-4.01V5.33h3.65l.26.01c.82.05 1.43.5 1.43 1.3 0 .61-.42 1.15-1.17 1.27v.04c.83.05 1.48.55 1.48 1.33zm-2.88-3.1a1.09 1.09 0 00-.14-.01h-1.36V7.5h1.5a.67.67 0 00.52-.67c0-.37-.23-.61-.52-.66zm.17 2.17a1.03 1.03 0 00-.18 0h-1.49V9.8h1.5l.17-.02c.29-.06.52-.34.52-.71 0-.38-.22-.64-.52-.72z"
}))));